import { render, staticRenderFns } from "./shopComment.vue?vue&type=template&id=9e4b5e5e&scoped=true"
import script from "./shopComment.vue?vue&type=script&lang=js"
export * from "./shopComment.vue?vue&type=script&lang=js"
import style0 from "./shopComment.vue?vue&type=style&index=0&id=9e4b5e5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4b5e5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e4b5e5e')) {
      api.createRecord('9e4b5e5e', component.options)
    } else {
      api.reload('9e4b5e5e', component.options)
    }
    module.hot.accept("./shopComment.vue?vue&type=template&id=9e4b5e5e&scoped=true", function () {
      api.rerender('9e4b5e5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopComment/shopComment.vue"
export default component.exports